import { AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, input, signal, viewChild } from '@angular/core';
import { TooltipDirective } from '@kaseya-design-components';

@Component({
  selector: 'itc-email',
  templateUrl: 'email.component.html',
  styleUrl: 'email.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective],
})
export class EmailComponent implements AfterViewInit {
  private readonly emailParts = computed(() => this.email().split('@'));

  readonly email = input.required<string>();
  readonly emailUsernameElement = viewChild.required<ElementRef<HTMLDivElement>>('emailUsernameElement');
  readonly emailUsername = computed(() => this.emailParts()[0]);
  readonly emailDomain = computed(() => this.emailParts()[1]);
  readonly isUsernameTruncated = signal(false);

  ngAfterViewInit(): void {
    this.checkIfUsernameTruncated();
  }

  private checkIfUsernameTruncated(): void {
    const element = this.emailUsernameElement().nativeElement;

    if (element.offsetWidth < element.scrollWidth) {
      this.isUsernameTruncated.set(true);
    }
  }
}
